export const debounce = <T extends (...args: never[]) => void>(
  func: T,
  wait: number
) => {
  let timeout: NodeJS.Timeout;
  let pending: Parameters<T> | null = null;
  const debounced = (...args: Parameters<T>) => {
    pending = args;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      pending = null;
      func(...args);
    }, wait);
  };
  debounced.cancel = () => {
    pending = null;
    clearTimeout(timeout);
  };
  debounced.flush = () => {
    if (!pending) return;
    clearTimeout(timeout);
    const args = pending;
    pending = null;
    func(...args);
  };
  return debounced;
};
